import Vue from "vue";
import Router from "vue-router";
import Home from "./Home.vue";
import Items from "./Items.vue";
import Images from "./Images.vue";
import Live from "./Live.vue";
import Login from "./Login.vue";
import Logout from "./Logout.vue";
import Splash from "./Splash.vue";

Vue.use(Router);

export default new Router({
  mode: "history",
  base: process.env.BASE_URL,
  routes: [
    {
      path: "/login",
      name: "login",
      component: Login
    },
    {
      path: "/logout",
      name: "logout",
      component: Logout
    },
    {
      path: "/home",
      name: "home",
      component: Home,
      children: [
        {
          path: "items",
          component: Items
        },
        {
          path: "images",
          component: Images
        },
        {
          path: "live",
          component: Live
        }
      ]
    },
    {
      path: "/",
      name: "splash",
      component: Splash
    }
  ]
});
